import { PlaceRef } from "@/types/entity"
import { LocationCategoryTier, LocationSearchHit } from "@/types/place"

import { baseApi } from "./base-api"

export interface SearchLocationsArgs {
  query: string
  limit?: number
  relativeToLocation?: PlaceRef
  categoryTier?: LocationCategoryTier | LocationCategoryTier[]
}

export interface SearchLocationsResponse {
  hits: LocationSearchHit[]
}

export const locationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    searchLocations: builder.query<
      SearchLocationsResponse,
      SearchLocationsArgs
    >({
      query: (args) => {
        const params = new URLSearchParams()
        params.append("q", args.query)
        params.append("limit", (args.limit ?? 5).toString())
        if (args.relativeToLocation) {
          params.append("relative_to", args.relativeToLocation)
        }
        if (Array.isArray(args.categoryTier)) {
          params.append("category_tier", args.categoryTier.join(","))
        } else if (args.categoryTier) {
          params.append("category_tier", args.categoryTier)
        }
        const url = `/api/locations/search?${params.toString()}`

        return {
          url,
          impressionIdHeader: "impression-id",
        }
      },
      providesTags: (_result, _error, args) => [
        {
          type: "LocationSearch",
          id: `${args.query}-${args.limit ?? 5}-${categoryTierCacheKey(args.categoryTier)}`,
        },
      ],
    }),
  }),
})

export const { useSearchLocationsQuery, useLazySearchLocationsQuery } =
  locationApi

function categoryTierCacheKey(
  categoryTier?: LocationCategoryTier | LocationCategoryTier[]
) {
  return Array.isArray(categoryTier)
    ? categoryTier.join(",")
    : (categoryTier ?? "all")
}
